const Xiaoben = () => import("@/page/xiaoben");
const Xiaobenmain = () => import("@/page/xiaoben/main");
const xiaobendetail = () => import("@/page/xiaoben/xiaobendetail");



const EditOffice = () => import('@/page/xiaoben/EditOffice');
const DepartDetail = () => import('@/page/xiaoben/DepartDetail')
const TextBook = () => import('@/page/xiaoben/textbook')

export default {
	path: "/Xiaoben",  
	component: Xiaoben,
	children: [{
		path: 'xiaobenmain',
		name: 'xiaobenmain',
		component: Xiaobenmain,
	}, {
		path: 'xiaobendetail',
		name: 'xiaobendetail',
		component: xiaobendetail,
	}, {
		path: 'departDetail',
		name: 'departDetail',
		component: DepartDetail,
	}, {
		path: 'editoffice',
		name: 'EditOffice',
		component: EditOffice,
	}, {
		path: 'textbook',
		name: 'textbook',
		component: TextBook,
	}]

};



// WEBPACK FOOTER //
// ./src/router/xiaoben.js